import React, { useEffect, useState } from 'react'
import { apiLocais } from '../../../api/apiLocais';
import { Grid, Typography, Alert, AlertTitle } from '@mui/material';
import LinearProgress from '@mui/material/LinearProgress';
import Categorias from './Categorias';
import { useNavigate } from 'react-router-dom';

const BaseLocais = () => {
    const navigate = useNavigate();
    
    const [allPlaces, setAllPlaces] = useState([]);
    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(true);
    
    // console.log("local")
    useEffect(() => {
        getLocais();
    }, []);

    const getLocais = async () => {

        const { status, message } = await apiLocais();
        if (status === 200) {
            setAllPlaces(message);
        } else if (status === 401) {
            alert(message);
            localStorage.removeItem('RL774DLxRi9E');
            navigate('/login');
        } else {
            setError(true);
        }

        setLoading(false);

    };

    return (
        <>
            <Grid item xs={12} sm={12} sx={{ padding: "10px", mb: 4 }}>
                <Typography sx={{ fontWeight: "bold", color: "#1b1464", textAlign: "center", fontSize: "24px" }} >
                    ESCOLHA A SEDE E O LOCAL
                </Typography>
            </Grid>

            {loading && <LinearProgress />}

            {(!loading && !error) &&
                <Grid item xs={12} md={12}>
                    <Categorias allPlaces={allPlaces} />
                </Grid>
            }

            {error && (
                <Alert severity="error">
                    <AlertTitle>Erro</AlertTitle>
                    Ocorreu um erro! Por favor, acione um gestor para mais informações.
                </Alert>
            )}

        </>

    )
}

export default BaseLocais
